export const BUSINESS_PARTNER_NEWS_EXPORT_ID = 'business-partner-news';

export const BUSINESS_PARTNER_NEWS_TITLE = 'Nuevos Clientes';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  emails: 'Correo',
  routes: 'Ruta',
  addresses: 'Ubicacion',
  createdAt: 'Fecha',
  status: 'Estado',
};
